<template>
  <v-container
    grid-list-md
  >
    <v-layout row>
      <v-flex
        md8
      >
        <GroupTable
          :selected="selected"
          @selected="selected = $event"
        />
      </v-flex>
      <v-flex
        column
        md4
        mt-0
      >
        <BlackBtn
          style="align-self: flex-end;"
          class="mb-2"
          @click="selected = newGroupDefault()"
        >
          <v-icon left>
            mdi-domain-plus
          </v-icon>
          グループを追加
        </BlackBtn>
        <GroupDetail
          :selected="selected"
          :loading="detailLoading"
          @register="onRegister"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { GroupTable, GroupDetail } from './components'
import { BlackBtn } from '@/components/ui'

export default {
  components: {
    GroupTable,
    GroupDetail,
    BlackBtn
  },
  data: () => ({
    newGroupDefault: () => ({
      id: 'new',
      type: 'area',
      parentGroupId: null,
      address: '',
      tel: '',
      remarks: '',
      representativeName: '',
      representativePassword: ''
    }),
    selected: {},
    detailLoading: false
  }),
  methods: {
    ...mapActions('groups', ['initGroupData', 'updateGroup']),
    ...mapMutations('app', ['setGlobalSnackBarText']),
    async onRegister (value) {
      this.detailLoading = true
      try {
        const { id, message } = await this.updateGroup(value)
        await this.initGroupData()

        this.setGlobalSnackBarText(message)
        Object.assign(this.selected, value)

        if (id) this.selected = {}
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>
